module.exports = __webpack_public_path__ + "static/media/question-icon.730b5105.png";